export enum EnvServer {
    Local = 'local',
    Dev = 'dev',
    Prod = 'prod',
    Stage = 'stage',
}
